import IsotopeMasonryGridInit from "../../components/isotope-masonry-grid/isotope-masonry-grid";
import "./css/style.scss";
import Portfolio from "./js/components/Portfolio";
import ReactDOM from "react-dom";
import React from "react";

document.addEventListener("DOMContentLoaded", function (event) {
    IsotopeMasonryGridInit();
});

ReactDOM.render(<Portfolio />, document.querySelector("#app"));
